<!--
================================================
Un composant affichant la liste des timerecords d'un workspace, avec différentes possibilités de groupement des données.

Url d'accès :
http://localhost:8080/fr/universal-studios/reports/summary/start=2021-08-30/end=2021-09-05?pjctArchShow=active&cltArchShow=active&groupCrit=client&mergeCrit=project


  CRITÈRE DE GROUPEMENT :
    * Le critère de groupement permet grouper les timerecords selon un critère ex : par user, par project, par timerecord

  CRITÈRE DE FUSION :
    * Le critère de fusion permet de fusionner plusieurs timerecords identiques afin d'afficher uniquement le temps total cumulés.

LIMITATION :
  * ⚠️ Ce composant souffre d'un problème de performance qui fait qu'il fonctionne mal pour les grande périodes de plusieurs mois. VA POSER PORBLÈME À TERME @todo à fixer dans https://gitlab.com/ousmane1/kronocloud/-/issues/608
  * Globalement ce composant a été très long à développer la gestion des tooltip notamment a été très chronophage
  * J'ai dû créer une variable intermédiaire this.tempo pour stocker les timerecords groupés & mergés
  * certaines icones ont la classe "is-hidden-touch-pause" cette classe n'existe pas dans Bulma, le suffixe "-pause" a été ajouté pour désactiver le masquage sur les devices touch. Elles sont laissées au cas où besoin de rollback @todo à supprimer si tout est ok à terme. @since 0.42.2

================================================
-->


<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
  <div id="WorkspaceTrSummaryComp" v-bind:class="{'darkMode':themeToDisplay=='dark'}">

    <div class="trSummaryFakeTable appBloc">


      <!-- //////////////////////////////////////////////////////-->
      <!-- Zone choix groupement -->
      <section class="criterionsSetup">
        <div class="columns">

          <div class="column manualGroupCol ">
            <h3>{{ $t('affichageDesDonnées') }}</h3>

            <div class="columns">
              <div class="column is-narrow">

                <div class="select ">
                  <select name="" v-bind:disabled="_.isEmpty(mergedTimerecords)"
                          v-on:click="$mixpanel.track('[WorkspaceTrSummaryComp] groupCriterion set to '+currentGroupCriterion),
                          ga4GlobalEventTrack('[WorkspaceTrSummaryComp] groupCriterion set' , {'criterion':currentGroupCriterion})"
                          id="currentGroupCriterion" v-model="currentGroupCriterion"
                          v-on:change="updateUrlConf('groupCrit')">
                    <option v-for="option in groupCriterions" v-bind:value="option.value"
                            v-if="option.value != currentMergeCriterion">
                      <!-- on n'affiche pas 2 fois le même critère dans le select de choix du groupement et le select de choix de fusion -->
                      {{ option.text }}
                    </option>
                  </select>
                </div>

              </div>
              <div class="column is-narrow">

                <div class="select ">
                  <select v-bind:disabled="_.isEmpty(mergedTimerecords)" name=""
                          v-on:click="
                            $mixpanel.track('[WorkspaceTrSummaryComp] mergeCriterion set to '+currentMergeCriterion),
                            ga4GlobalEventTrack('[WorkspaceTrSummaryComp] mergeCriterion set' , {value:currentMergeCriterion})
                            "
                          id="currentMergeCriterion" v-model="currentMergeCriterion"
                          v-on:change="updateUrlConf('mergeCrit')">
                    <option v-for="option in mergeCriterions" v-bind:value="option.value"
                            v-if="option.value != currentGroupCriterion">
                      <!-- on n'affiche pas 2 fois le même critère dans le select de choix du groupement et le select de choix de fusion -->
                      {{ option.text }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

      </section>
      <!-- //////////////////////////////////////////////////////-->

      <!-- QUAND LE COMPOSANT EST EN CHARGEMENT -->
      <div class="loaderZone" v-if="componentIsReady ==false">

        <table class="table is-fullwidth">
          <tbody>
          <loading-timerecord-comp v-for="index in 8" :key="index"></loading-timerecord-comp>
          </tbody>
        </table>
      </div>

      <!-- QUAND LE COMPOSANT A TERMINÉ DE CHARGÉ -->
      <div v-else class="componentReady">

        <no-result-comp v-if="_.isEmpty(mergedTimerecords)" v-bind:text="$t('aucunRésultat')"
                        v-bind:fontAwesomeIcon="['far','bookmark']"></no-result-comp>

        <div class="resultsCont" v-else>

          <!-- LIGNE HEAD -->
          <div class="columns is-mobile lineHead">
            <div colspan="" class="column is-capitalized is-1 fakeTh firstCol"><span class="tdContent">#</span></div>
            <div colspan="" class="column is-capitalized fakeTh"><span class="tdContent">{{ $t('nom') }}</span></div>
            <div colspan="" class="column is-capitalized fakeTh"><span class="tdContent">{{ $t('durée') }}</span></div>
            <div colspan="" class="column is-capitalized fakeTh"><span class="tdContent">{{ $t('pourcentage') }}</span>
            </div>
          </div> <!-- groupe A (use slug) -->

          <!--            <div class="columns " v-for="(groupA, indexUser) in mock"-->
          <div class="columns " v-for="(groupA, indexUser) in mergedTimerecords"
               v-bind:timerecord="groupA" :key="'groupA-' +indexUser">

            <div v-for="(trGroupedByTaskName, name) in groupA" class="groupContent  column"
                 v-bind:class="'groupLine'+indexUser">

              <!-- ##################################################################
              #################### PARTIE 1 - AFFICHAGE DES USERS ##################
              ################################################################## -->
              <div v-for="(trArrayOfSameTask, taskName1, trCount) in trGroupedByTaskName"
                   class="columns is-mobile groupLine " v-if="trCount==0">
                <!-- On affiche une seule fois la ligne contenant le nom prénom de l'user, donc on utilise que le 1er tr-->

                <!-- Comptage des entités total tr -->
                <div class="column fakeTd is-1-desktop is-narrow-touch  firstCol ">
                          <span class="groupCount tdContent" :class="'groupCount'+indexUser"
                                v-on:click="toggleSubGroupVisibility(name)">
                            <span
                                :content="$tc('nbResultat',calculateTrCountWithoutDuplicate(trGroupedByTaskName))"
                                v-tippy="{theme:themeToDisplay=='dark' ? 'cronotipdark' : 'cronotip'}"

                                class="count">{{ calculateTrCountWithoutDuplicate(trGroupedByTaskName) }}
                               <span>
                                 <font-awesome-icon v-if="subGroupVisibility[name].visible" class="icon chevron"
                                                    :icon="['fas', 'chevron-up']"/>
                                 <font-awesome-icon v-else class="icon chevron" :icon="['fas', 'chevron-down']"/>
                               </span>

                            </span>
                            <!--<span class="text">{{ $tc("nbResultat",calculateTrCountWithoutDuplicate(trGroupedByTaskName)) }}</span>-->
                          </span>
                </div>

                <!-- Nom de l'user -->
                <div class="column groupNameTd fakeTd">
                            <span v-if="currentGroupCriterion=='user'">
                              <trigram-comp v-bind:class="'is-hidden-touch'"
                                            v-bind:firstname="trArrayOfSameTask[0].user.firstname"
                                            v-bind:color="iterativeColor(indexUser).code"
                                            v-bind:last-name="trArrayOfSameTask[0].user.name"></trigram-comp>
                              <span class="tdContent touchFix username">
                                <span class="firstname">{{ trArrayOfSameTask[0].user.firstname }}</span>
                                <span class="name">{{ trArrayOfSameTask[0].user.name }}</span>
                              </span>
                            </span>

                  <span v-else-if="currentGroupCriterion=='project'" class="tdContent touchFix projectName">
        <!--                      <font-awesome-icon class="icon" :icon="['far', 'folder-open']" v-bind:style="{color:'#'+iterativeColor(indexUser,'vide' )}"/>-->

                              <span v-if="trArrayOfSameTask[0].project !=null"
                                    v-bind:style="{color:'#'+trArrayOfSameTask[0].project.color}"> <!-- ❗Pour les projets on utilise leur couleur -->
                                <font-awesome-icon class="icon" :icon="['far', 'folder-open']"/>
                                {{ trArrayOfSameTask[0].project.name }}
                              </span>
                              <span v-else>{{ $t('sansProjet') }}</span>
                            </span>

                  <span v-else-if="currentGroupCriterion=='client'" class="tdContent touchFix clientName">
        <!--                      <font-awesome-icon class="icon" :icon="['far', 'folder-open']" v-bind:style="{color:'#'+iterativeColor(indexUser,'vide' )}"/>-->

                              <span
                                  v-if="trArrayOfSameTask[0].project !=null && trArrayOfSameTask[0].project.client !=null"
                                  v-bind:style="{color:'#'+iterativeColor(indexUser).code}">
                                <font-awesome-icon class="icon" :icon="['fas', 'user-tie']"/>

                                {{ trArrayOfSameTask[0].project.client.name }}
                              </span>
                              <span v-else>{{ $t('sansClient') }}</span>
                            </span>

                </div>

                <!-- Durée totale du critère de groupement -->
                <div class="column groupDurationTd fakeTd" :class="'groupDurationTd'+indexUser">
                            <span class="tdContent">
                              <!-- ❗ note : "groupedTimerecords[name]" permet d'accéder à tous les tr du critère de groupement (ex si group par user "name" est le slug de l'user) -->
                              <font-awesome-icon :icon="['fas', 'stopwatch']" class="icon stopwatch is-hidden-touch"/>
                              <span
                                  class="duration">{{ calculateTimerecordCollectionDuration(groupedTimerecords[name]).hourAndMin }}
                              </span>
                            </span>

                </div>

                <!-- Pourcentage total du critère de groupement -->
                <div class="column fakeTd groupPercentTd" :class="'groupPercentTd'+indexUser">

                  <!-- ❗ note : "groupedTimerecords[name]" permet d'accéder à tous les tr de du critère de groupenet (ex : si group par user "name" ést le slug de l'user)-->

                  <span class="tdContent tooltip"
                        v-tippy="{theme:themeToDisplay=='dark' ? 'cronotipdark' : 'cronotip', showOnInit:false}"
                        v-bind:content="smartTooltipContent('group-percent', trArrayOfSameTask,name)"
                  >
                              <span class="percent">
                                {{ calculateDurationPercentage(calculateTimerecordCollectionDuration(groupedTimerecords[name]).seconds, globalDuration.seconds) }} %
                              </span>
                            </span>

                </div>

              </div>

              <!-- ##################################################################
              #################### PARTIE 2 - AFFICHAGE DES TIMERECORDS #############
              ################################################################## -->

              <div class="columns is-mobile">
                <div class="column">

                  <!-- Détail des timerecords d'un user -->
                  <transition-group name="fade" tag="div">
                    <div v-for="(trArrayOfSameTask, taskName1, trCount) in trGroupedByTaskName"
                         class="columns lineMerge" :class="'lineMerge'+trCount" v-bind:key="taskName1"
                         v-show="subGroupVisibility[name].visible">

                      <div class="column">
                        <div class="column" v-for="(tr, trIndexInThisTask) in trArrayOfSameTask"
                             v-if="trIndexInThisTask==0"
                        >
                          <!-- n'est affiché que si le tr est le premier de la liste (permet de n'afficher qu'une ligne pour plusieurs entités identiques (ex: si currentMergeCriterion vaut "timerecord" on affiche une seule ligne pour plusieurs timerecords identiques et on affiche le cumul des temps)- -->
                          <!-- INDEX -->
                          <div class="critereFusion columns is-gapless">

                            <!--------------------------- Tr count --------------------------->
                            <div class="column is-1 fakeTd firstCol milestoneTd is-hidden-touch">
                                   <span class="milestone">
                                      <span class="bar"></span>

                                     <!-- numéro du tr dans la liste -->

                                     <!-- ❗ Pour chaque critère de groupement, on ne colorise pas les tr qui n'on pas de critère de groupement
                                     (ex: si groupement par projet on ne colorise pas un tr sans projet)-->

                                     <!-- cas 0 : cas group par "user" on colorise -->
                                      <span v-if="currentGroupCriterion=='user'" class="numbers cas0"
                                            v-bind:style="{'border-color':'#'+iterativeColor(indexUser).code}">{{ trCount + 1 }}
                                      </span>

                                     <!-- cas 1 groupe par projet : on colorise avec la couleur du projet -->
                                     <span v-else-if="currentGroupCriterion=='project' && tr.project!=null"
                                           class="numbers cas1"
                                           v-bind:style="{'border-color':'#'+trArrayOfSameTask[0].project.color}">
                                       {{ trCount + 1 }}
                                     </span>

                                     <!-- cas 2 groupe par client : on colorise avec une couleur générée -->
                                      <span
                                          v-else-if="currentGroupCriterion=='client' && tr.project!=null &&  tr.project.client !=null "
                                          class="numbers cas2"
                                          v-bind:style="{'border-color':'#'+iterativeColor(indexUser).code}">
                                       {{ trCount + 1 }}
                                      </span>

                                     <!-- cas 3 : cas "aucun_projet" : on ne colorise pas -->
                                      <span v-else-if="currentGroupCriterion=='project' && tr.project == null"
                                            class="numbers cas3">
                                       {{ trCount + 1 }}
                                      </span>

                                     <!-- cas 4 : cas "aucun_client" : on ne colorise pas -->
                                      <span
                                          v-else-if="currentGroupCriterion=='client' && !_.get(tr, 'tr.project.client')"
                                          class="numbers cas4">
                                       {{ trCount + 1 }}
                                      </span>

                                    </span>
                            </div>


                            <!--------------------------- TASKNAME --------------------------->
                            <div class="column fakeTd mergeNameTd">
                                     <span class="tdContent mergeName">

                                       <!-- ICONES GROUP PAR USER  - - - - - - - - - - - - - - - - - - - -->
                                       <span v-if="currentGroupCriterion=='user'">
                                          <font-awesome-icon v-if="currentMergeCriterion=='timerecord'"
                                                             :icon="['far', 'bookmark']"
                                                             class="icon is-hidden-touch-pause cas0A"
                                                             v-bind:style="{color:'#'+iterativeColor(indexUser).code}"/>
                                          <font-awesome-icon v-else-if="currentMergeCriterion=='project'"
                                                             :icon="['far', 'folder-open']"
                                                             class="icon is-hidden-touch-pause cas0B"
                                                             v-bind:style="{color:'#'+iterativeColor(indexUser).code}"/>
                                       </span>

                                       <!-- ICONES GROUP PAR PROJECT - - - - - - - - - - - - - - - - - - - -->
                                       <span v-else-if="currentGroupCriterion=='project'">
                                          <!-- Si groupement par projet on colorise avec la couleur du projet -->
                                         <span v-if="currentMergeCriterion=='user'">

                                           <!-- on colorise l'icone user avec la couleur du projet si le tr possède un projet-->
                                            <span v-if="tr.project!=null ">
                                              <font-awesome-icon :icon="['fas', 'user']"
                                                                 class="icon is-hidden-touch-pause cas1A"
                                                                 v-bind:style="{color:'#'+trArrayOfSameTask[0].project.color}"/>
                                            </span>
                                           <span v-else>
                                              <font-awesome-icon :icon="['fas', 'user']"
                                                                 class="icon is-hidden-touch-pause cas1A"/>
                                           </span>

                                         </span>
                                         <!--<font-awesome-icon v-if="currentMergeCriterion=='user' && tr.project!=null " :icon="['fas', 'user']" class="icon is-hidden-touch cas1A" v-bind:style="{color:'#'+trArrayOfSameTask[0].project.color}" />-->

                                            <span v-if="currentMergeCriterion=='timerecord'">
                                              <!-- on colorise l'icone projet que si le projet n'est pas nul -->
                                              <font-awesome-icon v-if="tr.project!=null" :icon="['far', 'bookmark']"
                                                                 class="icon is-hidden-touch-pause cas1B"
                                                                 v-bind:style="{color:'#'+trArrayOfSameTask[0].project.color}"/>
                                              <font-awesome-icon v-else :icon="['far', 'bookmark']"
                                                                 class="icon is-hidden-touch-pause cas1C"/>
                                            </span>
                                       </span>

                                       <!-- ICONES GROUP PAR CLIENT - - - - - - - - - - - - - - - - - - - -->
                                       <span v-else-if="currentGroupCriterion=='client'">

                                         <span
                                             v-if="trArrayOfSameTask[0].project !=null && trArrayOfSameTask[0].project.client !=null">
                                            <font-awesome-icon v-if="currentMergeCriterion=='timerecord'"
                                                               :icon="['far', 'bookmark']"
                                                               class="icon is-hidden-touch-pause cas2A1"
                                                               v-bind:style="{color:'#'+iterativeColor(indexUser).code}"/>
                                         </span>
                                         <span v-else>
                                            <font-awesome-icon v-if="currentMergeCriterion=='timerecord'"
                                                               :icon="['far', 'bookmark']"
                                                               class="icon is-hidden-touch-pause cas2A2"/>
                                         </span>


                                         <span v-if="currentMergeCriterion=='project'">
                                         <!-- affichage de l'icon project si groupage par client ⚠️ on affiche la couleur du CLIENT -->
                                            <font-awesome-icon
                                                v-if="trArrayOfSameTask[0].project !=null && trArrayOfSameTask[0].project.client !=null"
                                                :icon="['far', 'folder-open']" class="icon is-hidden-touch-pause cas2B"
                                                v-bind:style="{color:'#'+iterativeColor(indexUser).code}"/>
                                           <font-awesome-icon v-else :icon="['far', 'folder-open']"
                                                              class="icon is-hidden-touch-pause cas2C"/>
                                         </span>

                                         <span v-if="currentMergeCriterion=='user'">
                                            <font-awesome-icon
                                                v-if="trArrayOfSameTask[0].project !=null && trArrayOfSameTask[0].project.client !=null"
                                                :icon="['fas', 'user']" class="icon is-hidden-touch-pause cas2D"
                                                v-bind:style="{color:'#'+iterativeColor(indexUser).code}"/>
                                            <font-awesome-icon v-else :icon="['fas', 'user']"
                                                               class="icon is-hidden-touch-pause cas2E"/>

                                         </span>
                                       </span>


                                       <!-- Si Critère de fusion taskName -->
                                       <span v-if="currentMergeCriterion=='timerecord'"
                                             class="mergeNameTxt mergeTr cas1">
                                         <span v-if="tr.taskName!=null">{{ tr.taskName }}</span>
                                         <span v-else class="emptyMerge">{{ $t('sansDescription') }}</span>
                                       </span>

                                       <!-- Si Critère de fusion project -->
                                       <span v-else-if="currentMergeCriterion=='project'"
                                             class="mergeNameTxt mergeProject cas2">
                                         <span v-if="tr.project != undefined && tr.project.name !=undefined">
                                           {{ tr.project.name }}
                                         </span>
                                         <span v-else class="emptyMerge">{{ $t('sansProjet') }}</span>
                                       </span>


                                       <!-- Si Critère de fusion user -->
                                       <span v-else-if="currentMergeCriterion=='user'"
                                             class="mergeNameTxt mergeUser cas4">
                                          <span class="firstname">{{ trArrayOfSameTask[0].user.firstname }}</span>
                                          <span class="name">{{ trArrayOfSameTask[0].user.name }}</span>
                                       </span>

                                       <!-- OCCURRENCES --------------------------->

                                          <span v-if="trArrayOfSameTask.length > 1">

                                            <sup class="tdContent occurences is-hidden-touch"
                                                 :content="smartTooltipContent('merge-occurence', trArrayOfSameTask,name,tr)"
                                                 v-tippy="{theme:themeToDisplay=='dark' ? 'cronotipdark' : 'cronotip'}"> {{ trArrayOfSameTask.length }}x</sup>

                                          </span>

                                        </span>

                            </div>

                            <!------------------ Durée du timerecord ------------->
                            <div class="column fakeTd durationTd">
                                     <span class="cumul tdContent">

                                       <font-awesome-icon :icon="['fas', 'stopwatch']"
                                                          class="icon stopwatch is-hidden-touch"/>

                                       <!--  Affichage du de la durée si critère de fusion par timerecord -->
                                       <span v-if="currentMergeCriterion=='timerecord'" class="mergedByTimerecord">
                                         <span v-if="trArrayOfSameTask.length==1"> <!-- si le tr de l'user est le seul avec ce taskName -->
                                           <span>
                                             {{ calculateTimerecordDuration(tr).hourAndMin }}
                                           </span>
                                         </span>
                                         <span v-else> <!-- sinon, d'autres tr avec ce taskName existent-->

                                           <!-- itération sur les timerecords au taskName identique d'un user pour calculer la durée totale de ces tr identiques (cette boucle est identique à celle plus haut mais on a besoin une seconde fois) -->
                                           <span v-for="(trDetail, trIndexInThisTask2) in trArrayOfSameTask">
                                              <!--  cumul = {{trIndexInThisTask2}} - {{trDetail.taskName}} - {{ calculateTimerecordDuration(trDetail).hourAndMin }} s-->
                                             <span class="cumulativeDuration" v-if="trIndexInThisTask2==0"><!-- on affiche une la durée cumulé seulement au 1er tour de boucle -->
                                               <span>
                                               {{ calculateTimerecordCollectionDuration(trArrayOfSameTask).hourAndMin }}
                                             </span>

                                            </span>
                                           </span>

                                         </span>
                                       </span>

                                       <!-- Affichage du de la durée si critère de fusion par projet -->
                                       <span
                                           v-else-if="currentMergeCriterion=='project'|| currentMergeCriterion =='client'"
                                           class="mergedByProject mergedByClient">
                                         <span v-if="trArrayOfSameTask.length==1"> <!-- si le tr de l'user est le seul avec ce critère de fusion (ex: projet ou client)-->

                                           <span>
                                             {{ calculateTimerecordDuration(tr).hourAndMin }}
                                           </span>
                                         </span>
                                         <span v-else> <!-- sinon, d'autres tr avec ce taskName existent-->

                                           <!-- itération sur les timerecords au taskName identique d'un user pour calculer la durée totale de ces tr identiques (cette boucle est identique à celle plus haut mais on a besoin une seconde fois) -->
                                           <span v-for="(trDetail, trIndexInThisTask2) in trArrayOfSameTask">
                                              <!--  cumul = {{trIndexInThisTask2}} - {{trDetail.taskName}} - {{ calculateTimerecordDuration(trDetail).hourAndMin }} s-->
                                             <span class="cumulativeDuration" v-if="trIndexInThisTask2==0"><!-- on affiche une la durée cumulé seulement au 1er tour de boucle -->
                                               <span>
                                               {{ calculateTimerecordCollectionDuration(trArrayOfSameTask).hourAndMin }}
                                             </span>


                                            </span>
                                           </span>

                                         </span>
                                       </span>

                                       <!-- Affichage du de la durée si critère de fusion par user -->
                                       <span v-else-if="currentMergeCriterion=='user'" class="mergedByUser">
                                         <span v-if="trArrayOfSameTask.length==1" class="casD1 unique"> <!-- si le tr est le seul avec ce prénom nom -->
                                           <!--                                   (cas D1)-->
                                           <span>
                                             {{ calculateTimerecordDuration(tr).hourAndMin }}
                                           </span>
                                         </span>
                                         <span v-else class="casD2 non-unique"> <!-- sinon, d'autres tr avec ce prénom nom existent-->

                                           <!--                                  (cas D2)-->
                                           <!-- itération sur les timerecords identiques pour calculer la durée totale de ces tr identiques (cette boucle est identique à celle plus haut mais on a besoin une seconde fois) -->
                                           <span v-for="(trDetail, trIndexInThisTask2) in trArrayOfSameTask">
                                              <!--  cumul = {{trIndexInThisTask2}} - {{trDetail.taskName}} - {{ calculateTimerecordDuration(trDetail).hourAndMin }} s-->
                                             <span class="cumulativeDuration casD2" v-if="trIndexInThisTask2==0"><!-- on affiche une la durée cumulé seulement au 1er tour de boucle -->

                                               <span>
                                               {{ calculateTimerecordCollectionDuration(trArrayOfSameTask).hourAndMin }}
                                             </span>

                                            </span>
                                           </span>

                                         </span>
                                       </span>

                                     </span>
                            </div>


                            <!-------------- Pourcentage du timerecord ------------------>
                            <div class="column mergePercentTd fakeTd is-hidden-touch2">
                                   <span class="tdContent  ">

                                     <span v-if="trArrayOfSameTask.length==1"> <!-- si le tr de l'user est le seul avec ce taskName-->

                                       <span class="tr%Unique tooltip"
                                             v-tippy="{theme:themeToDisplay=='dark' ? 'cronotipdark' : 'cronotip'}"
                                             v-bind:content="smartTooltipContent('tr-percent', trArrayOfSameTask,name,tr)"
                                       >{{
                                           calculateDurationPercentage(calculateTimerecordDuration(tr).seconds, calculateTimerecordCollectionDuration(groupedTimerecords[name]).seconds)
                                         }} %
                                       </span>
                                     </span>

                                     <span v-else> <!-- sinon, d'autres tr avec ce taskName existent-->
                                       <!--                               (cumul)-->
                                       <!-- itération sur les timerecords au taskName identique d'un user pour calculer le % total de ces tr identiques (cette boucle est identique à celle plus haut mais on a besoin une 3ème fois) -->
                                       <div v-for="(trDetail, trIndexInThisTask3) in trArrayOfSameTask">
                                         <span class="cumulativePercent" v-if="trIndexInThisTask3==0"><!-- on affiche le pourcentage cumulé seulement au 1er tour de boucle -->
                                           <!-- tooltip pourcentage si groupement par user & pourcent cumulés -->

                                           <span class="tr%Cumul tooltip "
                                                 v-tippy="{theme:themeToDisplay=='dark' ? 'cronotipdark' : 'cronotip'}"
                                                 v-bind:content="smartTooltipContent('tr-percent', trArrayOfSameTask,name,tr)"
                                           >️{{calculateDurationPercentage(calculateTimerecordCollectionDuration(trArrayOfSameTask).seconds, calculateTimerecordCollectionDuration(groupedTimerecords[name]).seconds)
                                             }} %
                                           </span>


                                        </span>
                                       </div>

                                     </span>

                                   </span>
                            </div>
                          </div>

                        </div>

                      </div>


                    </div>
                  </transition-group>
                </div>
              </div>

            </div>

          </div>


          <div style='clear:both;'></div><!-- évite que le tableau soit légèrement moins haut que son contenu-->
        </div>

      </div>

    </div>

    <!--////////////////////////////////// -->
  </div>
  <!--      </div>-->
  <!--    </div>-->

  <!--    https://www.npmjs.com/package/v-click-outside-->
  <!--    <div v-click-outside="onClickOutside"></div> -->
</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
import {mapState} from 'vuex'
import SentryMixin from "@/mixins/SentryMixin.js";
import ColorMixin from "@/mixins/ColorMixin.js";
import SpinnerLoaderComp from "@/components/SpinnerLoaderComp";
import GlobalErrorNotification from "@/mixins/GlobalErrorNotificationMixin.js";
import InterceptorMixin from "@/mixins/InterceptorMixin.js";
import TrackingMixin from "@/mixins/TrackingMixin";
import _ from "lodash";
import TimeMixin from "@/mixins/TimeMixin";
import TrigramComp from "@/components/TrigramComp";
import LoadingTimerecordComp from "@/components/PlaceholderTimerecordComp";
import NoResultComp from "@/components/NoResultComp";

export default {

  name: 'WorkspaceTrSummaryComp',
  components: {NoResultComp, LoadingTimerecordComp, SpinnerLoaderComp, TrigramComp},
  //utile dans vue dev tool
  mixins: [
    GlobalErrorNotification,
    SentryMixin,
    InterceptorMixin,
    TrackingMixin,
    TimeMixin,
    ColorMixin,
    TrackingMixin
  ],

  props: {
    /** pour typage et validation voir :
     *  https://fr.vuejs.org/v2/guide/components-props.html#Types-des-props
     *  https://fr.vuejs.org/v2/guide/components-props.html#Validation-des-props
     **/

    timerecords: {
      type: [Object], //  un objet d'objets timerecords
      required: true,
      default: () => ({}) // par défaut on créé un objet vide (évite une erreur au début du cycle du composant où prop est vide
    },

  },
  data: function () {
    return {
      tempo: [], // J'ai dû utiliser cette variable temporaire qui sert à stocker temporairement les timerecords groupés puis mergés
      locale: this.$route.params.locale,
      componentIsReady: false, // indique quand le composant est prêt à être affiché

      groupCriterions: [ // les différents critères de groupement disponibles ⚠️ NE PAS CHANGER L'ORDRE !
        {text: this.$t('GrouperParCollaborateur'), value: 'user'},
        {text: this.$t('GrouperParProjet'), value: 'project'},
        {text: this.$t('GrouperParClient'), value: 'client'},
      ],

      mergeCriterions: [ // les différents critères de fusion disponibles ⚠️ NE PAS CHANGER L'ORDRE !
        {text: this.$t('etAfficherLesPointages'), value: 'timerecord'},
        {text: this.$t('etAfficherLesProjets'), value: 'project'},
        {text: this.$t('etAfficherLesCollaborateurs'), value: 'user'},
      ],
      currentGroupCriterion: 'user', // le critère de croupement actuellement actif (parmi les clés "value" de this.groupCriterions)

      currentMergeCriterion: 'timerecord', // le critère de fusion actuellement actif (parmi les clés "value" de this.mergeCriterions)

      groupedTimerecords: null, // les timerecords groupés selon divers critères
      mergedTimerecords: null, // les timerecords fusionnés  selon divers critères

      globalDuration: { // La durée totale de tous les tr dans this.timerecords
        // hourAndMin: null, // au format heure et minute (ex : "4h 34m")
        seconds: null, // en secondes (ex: "3600")
      },

      subGroupVisibility: {}, //un objet servant à gérer la visibilité des .lineMerge | contient une clé --> nommée avec la valeur du critère de groupement est une clé "visible" contenant un boolean. Ex : {the-wachowski-0h54: {visible:true}}
    }
  },

  computed: {
    // computed props for store :
    ...mapState({
      user: state => state.user,
      themeToDisplay: state => state.app.themeToDisplay,
    }),

    //----------------------------------------------

    // other computed props :

    flatTimerecords: {
      // ❗ Puisque this.timerecord est passé via la prop timerecordsOfPeriodFiltered[periodName] depuis la reportsView, les timerecords sont groupés par jours, on doit donc au préalable les dégrouper avant de les re-grouper selon this.currentGroupCriterion
      get: function () {
        return _.flatMap(this.timerecords)
      },
    },

    _: { // Pour utiliser lodash dans la partie template html (https://stackoverflow.com/a/39027043/666416)
      get: function () {
        return _
      },
    },


  },
  watch: {
    // à chaque fois que la prop computed change, cette fonction s'exécutera
    timerecords: function () {

      // Requis pour attendre que les timerecords soient bien chargés
      if (this.timerecords != undefined) { // si les timerecords sont bien chargés
        this.groupedTimerecords = this.groupTimerecords()
        this.mergedTimerecords = this.mergeTimerecords(this.groupedTimerecords);
        this.globalDuration.seconds = this.calculateTimerecordCollectionDuration(this.flatTimerecords).seconds
        this.subGroupVisibilitySetup(this.groupedTimerecords)
        this.componentIsReady = true
      }
    },

    // Lorsque le critère de groupement change on modifie le groupement des données
    currentGroupCriterion: function () {
      this.componentIsReady = false;
      this.groupedTimerecords = this.groupTimerecords()
      this.mergedTimerecords = this.mergeTimerecords(this.groupedTimerecords);
      this.subGroupVisibilitySetup(this.groupedTimerecords)
      this.componentIsReady=true
    },


    // Lorsque le critère de fusion change on modifie le groupement et la fusion des données
    currentMergeCriterion: function () {
      this.componentIsReady = false;
      this.mergedTimerecords = this.mergeTimerecords(this.groupedTimerecords);
      this.componentIsReady=true
    },

  },


  methods: {

    /**
     * 🚧 🚧 🚧
     * WIP pour suite du développement de la génération des rapports .pdf
     *  //@todo utile pour ticket #581 https://gitlab.com/ousmane1/kronocloud/-/issues/581
     ***/
    // testPdf(){
    //   // test Génération pdf depuis html ::::::::::::::::::::::::::::::::::::::::::
    //   let docTest = this.$jsPDF({
    //     orientation:"landscape",
    //     unit:"mm",
    //     format: "a4" // @todo localiser letter
    //   })
    //
    //   // docTest.html("<html>foo <b>bar</b> </html>", {
    //   docTest.html(this.$refs.test, {
    //     callback: function (doc) {
    //       doc.save('test html 4-');
    //     },
    //     x: 10,
    //     y: 10
    //   });
    //   //  :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
    //   // test génération pdf depuis plusieurs images ::::::::::::::::::::::::::::::::::::::::::
    //   const doc = new self.$jsPDF({
    //     orientation: "landscape",
    //     unit: "mm",
    //     format: l10nDatas.paperFormat // @todo localiser letter
    //   });
    //
    //   let targetRefs = [
    //     this.$refs.summaryReport2Print,
    //     this.$refs.test // @todo ici il faut mettre l'attibut ref="test" sur un élément html
    //   ]
    //   // Création d'images multiples dans la promise (trouvé sur https://github.com/tsayen/dom-to-image/issues/242)
    //   Promise.all( targetRefs.map(node => this.$domtoimage.toJpeg(node)))
    //       .then(imagesDataUrl => {
    //         imagesDataUrl[0]
    //         imagesDataUrl[1]
    //         // console.log(imagesDataUrl)
    //
    //         // Ajout de l'image dans le document pdf
    //         doc.addImage(imagesDataUrl[0], "JPEG", 20, 20
    //             ,l10nDatas.imgWidth
    //             ,l10nDatas.imgHeight,
    //             null,
    //             'NONE'
    //         );
    //
    //         // ajout de la pge 2 contenant le workspaceTrSummaryComp
    //         doc.addPage(l10nDatas.paperFormat, "landscape")
    //         doc.addImage(imagesDataUrl[1], "JPEG", 20, 20
    //             ,l10nDatas.imgWidth
    //             ,l10nDatas.imgHeight,
    //             null,
    //             'NONE'
    //
    //         );
    //
    //         doc.html("<b>foo</b> bar") //test h
    //         doc.save("Cronocloud - " +filename);
    //
    //         // etcc
    //       })
    //       .catch(function(error){
    //         console.error(error)
    //       })
    // },


    capitalize(str) {
      return _.startCase(_.camelCase(str))
    },


    /**
     * Groupe les timerecords selon this.currentGroupCriterion (par user, client, project)
     **/
    groupTimerecords() {

      // let flatTimerecords = this.timerecords
      let groupedResult = []
      let self = this

      let timerecordsGroupedByUser
      switch (self.currentGroupCriterion) {
        case  'user':
          //  A. on groupe les tr par user
          timerecordsGroupedByUser = _.groupBy(this.flatTimerecords, function (timerecord) {
            return timerecord.user.slug
          });

          break;

        case 'project':

          timerecordsGroupedByUser = _.groupBy(this.flatTimerecords, function (timerecord) {
            // si pas de project on regroupe dans une clé "no_project"
            if (timerecord.project == null) {
              return 'no_project'
            } else { //sinon on groupe dans une clé portant le slug du projet
              return timerecord.project.slug
            }
          });

          break;

        case 'client':

          timerecordsGroupedByUser = _.groupBy(this.flatTimerecords, function (timerecord) {
            // si pas de client on regroupe dans une clé "no_client"
            if (timerecord.project == null || timerecord.project.client == null) {
              return 'no_client'
            } else { //sinon on groupe dans une clé portant le slug du client
              return timerecord.project.client.slug
            }
          });

          break;

      }

      return timerecordsGroupedByUser;
    },

    /**
     * Fusionnne les timerecords "identiques" (selon certains critères) afin de n'afficher que le total de temps cumulés.
     * Par exemple si le critère de fusion est par "timerecord" alors 2 pointages qui ont le même taskName ET le même projet s'afficheront sur une seule ligne.
     *
     * @param timerecords | les timerecords retournés par la méthode this.groupTimerecords()
     * @return Un array d'objet timerecords, groupés (comme dans this.groupTimerecords) mais dont les timerecords identiques ont été fusionnés.
     **/
    mergeTimerecords(timerecords) {

      this.tempo = [] // réinitialisation
      let groupedResult = []
      // B. itération sur tous les tr du critère de groupement les grouper selon le critère de merge
      let timerecordsGroupedByMergeCriterion
      let self = this
      _.forOwn(timerecords, function (userTimerecords, key) { // (ex : key = slug user)

        switch (self.currentMergeCriterion) {
          case  'timerecord':
            timerecordsGroupedByMergeCriterion = _.groupBy(userTimerecords, function (timerecord) {

              //@todo voir pour maj lors de ajout des tags https://gitlab.com/ousmane1/kronocloud/-/issues/40 #40
              if (timerecord.taskName != null) { //gestion préventive du #527 https://gitlab.com/ousmane1/kronocloud/-/issues/527

                if (timerecord.project != null) {
                  return timerecord.taskName + '-pjct:' + timerecord.project.slug // Pour être fusionnés les pointages doicent avoir le même taskName ET le même projet
                } else {
                  return timerecord.taskName

                }
              }

            })
            break;

          case 'project':
            timerecordsGroupedByMergeCriterion = _.groupBy(userTimerecords, 'project.slug')
            break;

          case 'client':
            timerecordsGroupedByMergeCriterion = _.groupBy(userTimerecords, 'project.client.slug')
            break;

          case 'user':
            timerecordsGroupedByMergeCriterion = _.groupBy(userTimerecords, 'user.slug')
            break;


        }

        // regroupement des tr de chaque user dans une clé portant le nom du slug de ce dernier
        groupedResult[key] = timerecordsGroupedByMergeCriterion;
        self.tempo.push({[key]: timerecordsGroupedByMergeCriterion})
      })

      return this.tempo
    },


    /**
     * Calcule la durée de timerecord
     * @param timerecord | un objet timerecord
     **/
    calculateTimerecordDuration(timerecord) {
      let duration = this.calculateDuration(this.$moment, timerecord.timeIn, timerecord.timeOut)


      let res = {
        hourAndMin: this.formatDuration(duration, this.$moment, this.locale),
        seconds: this.$moment.duration(duration).asSeconds()
      }
      return res
    },

    /**
     Calcule la durée totale de timerecordsCollection
     Créer à partir de la méthode éponyme du PeriodDurationComp
     @param timerecordsCollection Un array d'objet timerecord
     */
    calculateTimerecordCollectionDuration(timerecordsCollection) {
      let periodDuration = null
      let groupDuration = null
      let self = this

      _.forOwn(timerecordsCollection, function (timerecord) {
        groupDuration = groupDuration + parseInt(self.calculateDuration(self.$moment, timerecord.timeIn, timerecord.timeOut)._milliseconds)

      })

      // on ajoute la durée du groupe au total de la période
      periodDuration = +groupDuration

      // on créé un nouvel objet moment duration avec notre total en milliseconde
      let momentDuration = self.$moment.duration(periodDuration)
      let duration = {
        hourAndMin: this.formatDurationInHourAndMin(momentDuration, this.$moment, this.locale),
        seconds: this.$moment.duration(momentDuration).asSeconds(),

      }
      return duration

    },


    /**
     Calcule le pourcentage que représente durationPartpar rapport à durationRef
     Retourne un nombre avec 2 décimales (ex: 13,45)
     @param durationPart | int durée en secondes
     @param durationRef | int durée en secondes
     @return
     */
    calculateDurationPercentage(durationPart, durationRef) {
      let res = durationPart * 100 / durationRef
      return res.toFixed(2);
    },


    /**
     * Calcule le nombre de timerecords d'un critère de groupement en excluant les doublons dont le critère de merge est identique (ex: si groupement par user et merge par timerecord : si deux timerecords ont le taskName "Sales" le count sera "1")
     *
     * Utilisé pour calculé le nombre de tr total du critère de groupement actuel en éleminant les doublons du critère de fusion)
     * @param timerecords Un objet dont chaque propriété est composé  :
     *  - d'une clé dont le nom est la valeur affichée dans la ligne de merge
     *  - d'une valeur égale à un tableau de timerecord
     *   ex : Test occurences taskName identique 🍪-pjct:matrix-4: Array(2)

     */
    calculateTrCountWithoutDuplicate(TrCollection) {

      let count = 0
      _.forOwn(TrCollection, function (timerecords, key) { // key = user slug ?
        // console.debug(key)
        // console.debug(timerecords)
        // console.debug(timerecords.length)
        // if(timerecords.length >0 && timerecords.length < 1){
        //   count++
        // }
        // else{
        //   count = count + timerecords.length
        // }
        count++
      })

      return count
      ///// FIN WIP --------

    },

    /**
     * Créé un objet contenant la visibilité des lignes de détails de tr
     *
     * La clé de cet objet est égal au slug de l'entité du critère de groupement et la valeur est soit "true" soit "false".
     *
     * Si vaut true alors la ligne de detail des tr (.lineMerge) du critère de groupement correspondant sera affichée
     *
     * @return object | Ex : si le critère de groupement est par "user" alors retourne un objet de type { "pam-meesly-dunder-mufflin-com": "false", "jim-halbert-dunder-mufflin-com": "true" }
     **/
    subGroupVisibilitySetup(groupedTimerecords) {
      let self = this
      _.forOwn(groupedTimerecords, function (timerecords, key) { // ex: key = slug user

        self.$set(self.subGroupVisibility, key, {visible: false}) // ⚠️ il faut utiliser $set pour que les nouvelles propriétés soient réactives

      })
    },

    /**
     * Permute la visibilité des lignes des timerecords
     * @param key String | indicateur de la ligne de groupement pour laquelle on veut afficher les détails ex: si le groupement est par user, key est un slug user type :"pam-meesly-dunder-mufflin-com"
     **/

    toggleSubGroupVisibility(key) {


      if (this.subGroupVisibility[key].visible == true) {
        this.subGroupVisibility[key].visible = false
        let self = this
      } else {
        this.subGroupVisibility[key].visible = true
      }

    },

    /**
     * @param tooltip L'identifiant de la tooltip
     * @param groupedTimerecords this.groupedTimerecords
     * @param trArrayOfSameTask Array | un array d'objet timerecord
     * @param groupKeyName  String | La clé représentant la valeur de groupement actuelle, ex si critère de groupement par projet, groupKeyName est un nom de projet
     * @param tr object | Objet timerecord
     **/
    smartTooltipContent: function (tooltip, trArrayOfSameTask, groupKeyName, tr) {
      let res
      switch (tooltip) {

        case 'group-percent':
          let percent
          percent = this.calculateDurationPercentage(this.calculateTimerecordCollectionDuration(this.groupedTimerecords[groupKeyName]).seconds, this.globalDuration.seconds)

          switch (this.currentGroupCriterion) {
              // Pourcentage du group | group par user - - - - - - - - - - - - - - - - - - - - - -
            case  'user':

              // création des variables communes pour le critère de groupement
              let name = this.capitalize(trArrayOfSameTask[0].user.firstname)

              // Pourcentage du group | group par user |
              return res = this.$t('tooltip-leTravailDeUntelReprésenteXPourcentDeLaPériode', {
                name: name,
                percent: percent,
              })

              break;

              // Pourcentage du group | group par project - - - - - - - - - - - - - - - - - - - - - -
            case  'project':

              // création des variables communes pour le critère de groupement
              let projectName = this.capitalize(trArrayOfSameTask[0].project != null ? trArrayOfSameTask[0].project.name : this.$t('sansProjet'))

              // Pourcentage du group | group par project |
              return res = this.$t('tooltip-leProjetXReprésenteXPourcentDeLaPériode', {
                percent: percent,
                project: projectName,
              })

              break;

              // Pourcentage du group | group par client - - - - - - - - - - - - - - - - - - - - - -
            case  'client':

              // création des variables communes pour le critère de groupement
              let clientName = this.capitalize(trArrayOfSameTask[0].project != null && trArrayOfSameTask[0].project.client != null ? trArrayOfSameTask[0].project.client.name : this.$t('sansClient'))

              // Pourcentage du group | group par client |
              return res = this.$t('tooltip-LeClientXReprésenteXPourcentDuTotalDeLaPériode', {
                percent: percent,
                client: clientName,
              })

              break;
          }

          break;

        case  'tr-percent':

          let name // la valeur du critère de groupement (ex si groupement pa user sera un Prénom)

          switch (this.currentGroupCriterion) {

              // Pourcentage du tr | group par user - - - - - - - - - - - - - - - - - - - - - -
            case  'user':
              name = this.capitalize(trArrayOfSameTask[0].user.firstname)

              switch (this.currentMergeCriterion) {

                  // Pourcentage du tr | group par user | merge par tr
                case  'timerecord':

                  let percentSpe

                  // si le tr à une seule occurence calcul du percent normal
                  if(trArrayOfSameTask.length==1){

                    percentSpe= this.calculateDurationPercentage(
                        this.calculateTimerecordDuration(tr).seconds,
                        this.calculateTimerecordCollectionDuration(this.groupedTimerecords[groupKeyName]).seconds)

                  }
                  // si le tr à plus d'une occurence calcul du cumulativePercent
                  else{
                    percentSpe= this.calculateDurationPercentage(
                        this.calculateTimerecordCollectionDuration(trArrayOfSameTask).seconds,
                        this.calculateTimerecordCollectionDuration(this.groupedTimerecords[groupKeyName]).seconds)

                  }

                  res = this.$t('tooltip-UntelApasséXPourcentDeSonTempsSur', {
                    taskname: tr.taskName,
                    percent: percentSpe,
                    name: name
                  })
                  return res
                  break;

                  // Pourcentage du tr | group par user | merge par project
                case  'project':
                  res = this.$t('tooltip-UntelApasséXPourcentDeSonTempsSurLeProjetX', {
                    percent: this.calculateDurationPercentage(this.calculateTimerecordCollectionDuration(trArrayOfSameTask).seconds, this.calculateTimerecordCollectionDuration(this.groupedTimerecords[groupKeyName]).seconds),
                    project: tr.project != null ? tr.project.name : this.$t('sansProjet'),
                    name: name
                  })
                  return res
                  break;
              }


              break;


              // Pourcentage du tr | group par client - - - - - - - - - - - - - - - - - - - - - -
            case  'client':

              // création des variables communes pour le critère de groupement
              let clientName = this.capitalize(trArrayOfSameTask[0].project != null && trArrayOfSameTask[0].project.client != null ? trArrayOfSameTask[0].project.client.name : this.$t('sansClient'))

              let clientPercentDuration = this.calculateDurationPercentage(
                  this.calculateTimerecordCollectionDuration(trArrayOfSameTask).seconds,
                  this.calculateTimerecordCollectionDuration(this.groupedTimerecords[groupKeyName]).seconds)

              switch (this.currentMergeCriterion) {

                  // Pourcentage du tr | group par client | merge par tr
                case  'timerecord':
                  res = this.$t('tooltip-XReprésenteXPourcentDuTempsPasséPourX', {
                    task: tr.taskName,
                    percent: clientPercentDuration,
                    client: clientName,
                  })
                  return res
                  break;

                  // Pourcentage du tr | group par client | merge par project
                case  'project':
                  res = this.$t('tooltip-XPourcentDuTempsConsacréAuClientXAÉtéPasséSurLeProjet', {
                    percent: clientPercentDuration,
                    client: clientName,
                    project: tr.project != null ? tr.project.name : this.$t('sansProjet'),
                  })
                  return res
                  break;
              }


              break;

              // Pourcentage du tr | group par project - - - - - - - - - - - - - - - - - - - - - -
            case  'project':

              // création des variables communes pour le critère de groupement
              let projectName = this.capitalize(trArrayOfSameTask[0].project != null && trArrayOfSameTask[0].project != null ? trArrayOfSameTask[0].project.name : this.$t('sansProjet'))

              let percent = this.calculateDurationPercentage(
                  this.calculateTimerecordCollectionDuration(trArrayOfSameTask).seconds,
                  this.calculateTimerecordCollectionDuration(this.groupedTimerecords[groupKeyName]).seconds)

              switch (this.currentMergeCriterion) {

                  // Pourcentage du tr | group par project | merge par tr
                case  'timerecord':
                  res = this.$t('tooltip-XPourcentDuProjetXAÉtéPasséSur', {
                    task: tr.taskName,
                    percent: percent,
                    project: projectName,
                  })
                  return res
                  break;

                  // Pourcentage du tr | group par project | merge par user
                case  'user':
                  res = this.$t('tooltip-XPourcentDuTempsConsacréAuProjetXAÉtéEffectuéPar', {
                    user: tr.user.firstname,
                    percent: percent,
                    project: projectName,
                  })
                  return res
                  break;

              }

              break;

          }

          // Group par client Merge par user
          if (this.currentGroupCriterion == 'client' && this.currentMergeCriterion == 'user') {
            //cas A6
            res = this.$t('tooltip-XPourcentDuTempsConsacréAuClientXAÉtéEffectuéPar', {
              task: tr.taskName,
              percent: this.calculateDurationPercentage(
                  this.calculateTimerecordCollectionDuration(trArrayOfSameTask).seconds,
                  this.calculateTimerecordCollectionDuration(this.groupedTimerecords[groupKeyName]).seconds),
              client: this.capitalize(trArrayOfSameTask[0].project != null && trArrayOfSameTask[0].project.client != null ? trArrayOfSameTask[0].project.client.name : this.$t('sansClient')),
              user: tr.user.firstname
            })
            return res
          }

          break;

        case  'merge-occurence':

          // let name // la valeur du critère de groupement (ex si groupement pa user sera un Prénom)

          switch (this.currentGroupCriterion) {

              // Pourcentage du tr | group par user - - - - - - - - - - - - - - - - - - - - - -
            case  'user':
              //
              // percent =  this.calculateDurationPercentage(
              //     this.calculateTimerecordDuration(tr).seconds,
              //     this.calculateTimerecordCollectionDuration(this.groupedTimerecords[groupKeyName]).seconds)
              // name = this.capitalize(trArrayOfSameTask[0].user.firstname)
              //
              switch (this.currentMergeCriterion) {

                  // occurence du tr | group par user | merge par tr
                case  'timerecord':
                  res = this.$t('tooltip-xOccurencesPourLaTâche', {
                    taskName: tr.taskName,
                    occurrence: trArrayOfSameTask.length,
                    name: this.capitalize(trArrayOfSameTask[0].user.firstname)
                  })
                  return res
                  break;

                  // occurence du tr | group par user | merge par project
                case  'project':
                  res = this.$t('tooltip-leProjetXApparaitXFoisDansLeTravailDeUntel', {
                    occurrence: trArrayOfSameTask.length,
                    project: tr.project != null ? tr.project.name : this.$t('sansProjet'),
                    user: this.capitalize(tr.user.firstname)
                  })
                  return res
                  break;
              }


              break;


              // ocurence du tr | group par client - - - - - - - - - - - - - - - - - - - - - -
            case  'client':

              // création des variables communes pour le critère de groupement
              let clientName = this.capitalize(trArrayOfSameTask[0].project != null && trArrayOfSameTask[0].project.client != null ? trArrayOfSameTask[0].project.client.name : this.$t('sansClient'))

              switch (this.currentMergeCriterion) {

                  // occurence du tr | group par client | merge par tr
                case  'timerecord':
                  res = this.$t('tooltip-xOccurencesDeLaTacheXPourLeClientX', {
                    task: tr.taskName,
                    occurrence: trArrayOfSameTask.length,
                    client: clientName,
                  })
                  return res
                  break;

                  // tootltip occurence | group par client | merge par projet
                case  'project':
                  res = this.$t('tooltip-xOccurencesDuProjetXPourLeClientX', {
                    occurrence: trArrayOfSameTask.length,
                    client: clientName,
                    project: tr.project != null ? tr.project.name : this.$t('sansProjet'),
                  })
                  return res
                  break;

                  // tootltip occurence | group par client | merge par user
                case  'user':
                  res = this.$t('tooltip-UntelATravailléXFoisPourLeClientX', {
                    occurrence: trArrayOfSameTask.length,
                    client: clientName,
                    userName: this.capitalize(tr.user.firstname)
                  })
                  return res
                  break;

              }

              break;

              // ocurrences du tr | group par project - - - - - - - - - - - - - - - - - - - - - -
            case  'project':

              switch (this.currentMergeCriterion) {

                  // ocurrences du tr | group par project | merge par user
                case  'user':
                  res = this.$t('tooltip-XATravailléXFoisPourLeProjetX', {
                    project: tr.project != null ? tr.project.name : this.$t('sansProjet'),
                    occurrence: trArrayOfSameTask.length,
                    user: this.capitalize(tr.user.firstname),
                  })
                  return res
                  break;

                  // occurences| group par project | merge par timerecord
                case  'timerecord':
                  res = this.$t('tooltip-laTâcheXApparaitXFoisDansLeProjetX', {
                    project: tr.project != null ? tr.project.name : this.$t('sansProjet'),
                    taskName: tr.description != null ? tr.description : this.$t('sansDescription'),
                    occurrence: trArrayOfSameTask.length,
                  })
                  return res
                  break;

              }

              break;

          }


          break;
      }

    },

    /**
     Configure le composant en fonction des paramètres d'url
     @see router.js
     Si le query param groupCrit est fournit, il configurera la valeur de this.currentGroupCriterion
     Si le query param mergeCrit est fournit, il configurera la valeur de this.currentMergeCriterion
     */
    initConfigFromUrl() {

      // si la query param "groupCrit" est fournit dans l'url on l'utilise pour configurer les select
        switch (this.$route.query.groupCrit) {
          case undefined:  // valeur par défaut si le critère n'est pas défini
              this.currentGroupCriterion = 'user';
              this.$router.push({query: {...this.$route.query, groupCrit: this.currentGroupCriterion}});
            break;

          case  'user':
              this.currentGroupCriterion = 'user';
            break;
          case  'project':
            this.currentGroupCriterion = 'project';
            break;
          case  'client':
            this.currentGroupCriterion = 'client';
            break;

        }

        switch (this.$route.query.mergeCrit) {

          case undefined:  // valeur par défaut si le critère n'est pas défini
            this.currentMergeCriterion = 'timerecord';
            this.$router.push({query: {...this.$route.query, mergeCrit: this.currentMergeCriterion}});
            break;

          case  'user':
            this.currentMergeCriterion = 'user';
            break;
          case  'project':
            this.currentMergeCriterion = 'project';
            break;
          case  'timerecord':
            case null :  // valeur par défaut si le critère n'est pas défini
            this.currentMergeCriterion = 'timerecord';
            break;
        }
    },

    /**
     Met à jour les query param groupCrit et mergeCrit par rapport aux critères actuels de groupement et fusion.
     Permet de mettre à jour l'url lorsque les liste #currentGroupCriterion et currentGroupCriterion changent
     @param queryParam Le nom du query param à mettre à jour
     @value la valeur à attribuer au query param
     */
    updateUrlConf(queryParam, value) {

      switch (queryParam) {

        case  'groupCrit':
          this.$router.push({query: {...this.$route.query, groupCrit: this.currentGroupCriterion}});
          break;

        case 'mergeCrit':
          this.$router.push({query: {...this.$route.query, mergeCrit: this.currentMergeCriterion}});
          break;

      }

    }

  },

  // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
  mounted: function () {

    /*
     * Event report_view_fetching_data, pour affichage du loader si reportsView est en train de mettre à jour les données
    */
    this.$root.$on('report_view_fetching_data', (isLoading) => {
      isLoading ? this.componentIsReady = false : this.loadingData = true;
    })

    // Configuration depuis les parmètres d'url
    this.initConfigFromUrl()

  },
  beforeDestroy() {
  },
}
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss">
</style>

<style scoped lang="scss">
@import "../../assets/css/globalVar.scss";
@import "../../assets/css/bulmaResponsiveDep.scss";

#WorkspaceTrSummaryComp {

  $taskNameWidth: 10rem;
  // permet de faire en sorte que sur touch les (fake) cases du tableau soient à peu près alignées en standartisant la taille de .taskName qui est l'élément dont la longeur varie le plus

  $durationTdLeftRightMargin: .2rem; // permet de faire en sorte que sur touch les (fake) cases du tableau soient à peu près alignées en définissant une marge gauche droite identique sur les cases duration dans .groupLine et .lineMerge
  $durationTdWidth: 5rem; // permet de faire en sorte que sur touch les (fake) cases du tableau soient à peu près alignées


  //background-color: white;

  //////////////////////////////////////////
  // LIGHT THEME ///////////////////////////

  .loaderZone {
    //padding: 1rem;
  }


  .trSummaryFakeTable {
    margin-top: 4rem;
    //clear: both;
    //overflow: auto; // évite que le tableau soit légèrement plus petit que son contenu
    //padding: 0;
    font-size: .9rem;
    background-color: #fff;
    /* est affcihé comme un tableau mais n'en est pas un (pour des raisons de complexité de l'affichage des données*/
    border: solid 1px #ccc;
    box-shadow: 0 1px 4px #ccc;

    $fakeColPaddingLeft: .5rem; // un padding gauche pour décaler les contenus
    $fakeColVertPadding: .6rem;

    .columns {
      &:last-child {
      }
    }

    // Reset
    .columns {
      padding: 0;

    }

    .column {

    }


    .criterionsSetup {
      background-color: $superLightBlue;
      padding: 1.5rem;
      color: $brandFourth;
      text-align: left;
      border-bottom: solid 1px darken($superLightBlue, 10%);

      h3 {
        font-weight: bold;
        margin-bottom: .5rem;
      }

      .select {
        select {
          font-weight: bold;
          font-size: .95rem;
          color: $brandThird;

          &:disabled {
            background-color: white;
          }
        }
      }

      .column {
      }

      .orColumn {
        font-size: 1.5rem;
        text-transform: capitalize;
        color: $brandFourth;

        .or {
          padding-left: 1rem;
          border-left: 1px solid lighten($brandFourth, 20%);
          margin-right: 1rem;
        }
      }

    }

    ///////////////////
    .lineHead {
      background-color: #f9f9f9;
      //padding: 0;
      color: $brandFourth;
      font-weight: bold;
      margin: 0;
      //padding: .4rem 0;
    }

    .fakeTh {
      text-align: left;
      padding: ($fakeColVertPadding*2) 0;

      .tdContent {
        margin-bottom: .4rem;
        margin-top: 0;
      }

    }


    .fakeTd {
      padding: $fakeColVertPadding 0;
      display: inline-block;
      text-align: left;
    }

    .tdContent {
      margin-top: .5rem;
      margin-left: $fakeColPaddingLeft;

      display: inline-block;

      .icon {
        font-size: .9rem;
        vertical-align: bottom;
        margin-right: .2rem;

      }

    }


    .firstCol { //sert à décaler les contenus des première colonne de la gauche
      padding-left: 1rem !important;
      @include touch{
        padding-left: 0 !important;
      }

    }

  }

  .groupContent {
    padding-top: 0;
    padding-bottom: 0;

    .lineMerge {
      &:last-child {
        border-bottom-color: transparent !important; // la dernière ligne des .lineMerge est transparente
      }
    }
  }

  .groupLine {

    background-color: #f4f4f4;
    border-top: solid 1px lighten($brandFourth, 30%);
    border-bottom: 1px dashed lighten($brandFourth, 30%);

    margin: 0;
    padding: .9rem 0;
    color: $brandThird;
    font-weight: bold;


    .tdContent { // retouche des cases tdContent uniquement dans la .groupLine
      margin-top: .2rem;
      padding-bottom: .5rem;
      padding-top: .3rem;
    }

    .groupCount {

      cursor: pointer;

      .count {
        border: solid 1px $brandFourth;
        padding: .3rem .6rem;
        border-radius: 2rem;
        margin: auto;

        .icon {
          padding-top: .2rem;
          margin-left: .2rem;
        }
      }

      .text {
        font-size: .85rem;
        color: $brandFourth;
        margin-left: .2rem;
      }
    }

    .groupNameTd {

      position: relative;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      @include touch {
        min-width: 7rem;
      };

      .tdContent.touchFix{ // On contrôle l'affichage des tdContent dans groupNameTd sur touch (concerne .username, .clientName et .projectName)

        // limitation de la longeur d'affichage du nom de la lineMerge
        display: inline-block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;

        @include touch {
          display: block !important;
          max-width: 6rem;
        }
      }
      .TrigramComp {

        top: .7rem;
        position: absolute;
      }

      .username {
        color: #333;
        margin-left: 2.5rem; // pour décaler par rapport au .TrigramComp

        @include touch {
          //background-color: lime;
          margin-left: .5rem; // annule le décalage par rapport au .TrigramComp car masqué sur touch
        }

        .firstname {
          margin: auto .3rem auto .7rem;
          text-transform: capitalize;

          @include touch {
            margin-left: .5rem;
          }
        }

        .name {
          margin-right: .3rem;
          text-transform: uppercase;
        }
      }
    }

    .groupDurationTd {
      @include touch {
        margin: 0 $durationTdLeftRightMargin;
        min-width: $durationTdWidth;
        //background-color: lightblue;
      }

      .icon {
        color: $brandFourth
      }
    }

  }

  .lineMerge {

    background-color: white;
    color: $brandThird;
    margin: 0;
    border-bottom: dashed 1px #ccc;
    transition: background-color 250ms;

    &:hover {
      background-color: #f9f9f9;

      .taskName {
      }
    }

    .columns {
    }

    .column {
      text-align: left;
      padding: .1rem 0 !important;
      margin: .1rem 0;
    }

    .milestoneTd {
      text-align: center;


      .milestone {
        margin: 0 auto;

        padding: .4rem 1rem;
        display: inline-block;
        position: relative;

        .bar {
          width: 2px;
          height: 2.7rem;
          display: block;
          background-color: #ccc;
          position: absolute;
          margin: auto;
          left: 1.8rem;
          top: -.1rem;
          z-index: 5;

        }

        .numbers {
          font-weight: bold;
          width: 1.5rem;
          display: inline-block;
          text-align: center;
          padding-top: .05rem;
          color: #999;
          border: solid 1px #ccc;
          border-radius: 1rem;
          z-index: 12;
          position: relative;
          font-size: .9rem;
          background-color: white;

        }
      }
    }

    .mergeNameTd {
      .mergeName {
        color: #666;
        position: relative;
        font-weight: bold;

        .mergeNameTxt {
          .firstname {
            margin-right: .2rem;
            text-transform: capitalize;
          }

          .name {
            text-transform: uppercase;
          }

          .emptyMerge {
            font-style: italic;
            color: #ccc;
          }
        }

        .icon {
          font-size: .9rem;
          vertical-align: middle;
          margin-right: .4rem;
          color: #ccc;

        }


        @include touch {
          padding-left: .5rem;
          max-width: $taskNameWidth;
          min-width: $taskNameWidth;
        }

        .occurences {

          font-size: .8rem;
          color: #999;
          font-weight: bold;
          margin-left: .5rem;
          position: absolute;
          text-align: center;
          border: solid 1px #999;
          border-radius: 4rem;
          background-color: white;
          padding: .1rem .25rem;
          top: -.5rem;
        }
      }

    }

    .durationTd {
      font-weight: bold;

      @include touch {
        margin: 0 $durationTdLeftRightMargin;
        min-width: $durationTdWidth;
      }

      .icon {
        color: #ccc;
      }


    }

    .mergePercentTd {
      font-weight: bold;
      color: $brandFourth;
    }

  }

  // transition pour le masquage des tr
  .fade-enter-active, .fade-leave-active {
    transition: opacity .25s ease-in;

  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;

  }


  /////////////////////////////////////////
  // DARK THEME ///////////////////////////
  &.darkMode {

    $bgColor: $darkTableTdBg;


    .trSummaryFakeTable {
      box-shadow: 0 1px 4px #222;
      border-color: $darkTableBorder;
      background-color: $bgColor;
      color: $darkTxt;

      .criterionsSetup {
        background-color: lighten($darkBg, 4%);
        border-bottom-color: $darkBg;

        h3 {
          color: $darkLightBlue;
        }

        select {
          color: $darkTxt;

          &:disabled {
          }
        }

        .orColumn {
          .or {
            border-color: $darkLightBlue;
            color: $darkLightBlue;
          }
        }
      }

      .lineHead {
        background-color: $darkTableHeadBg
      }

      .groupLine {
        background-color: darken($bgColor, 3%);
        border-bottom-color: lighten($darkTableHeadBg, 15%);
        border-top-color: lighten($darkTableHeadBg, 15%);

        .username {
          color: $darkTxt
        }

        .fakeTd {

        }

        .groupCount {
          .count {
            border-color: #666;

          }

        }
      }

      .lineMerge {
        background-color: $darkTableTdBg;
        border-color: $darkTableBorder;

        &:hover {
          background-color: darken($darkTableTdBg, 2%);

          .taskName {
            //color: $darkLightBlue !important;
          }

        }

        .mergeNameTd {
          .mergeName {
            color: $darkContrastTxt;

            .icon {
              color: #666;
            }
          }

          .emptyMerge {
            color: darken($darkContrastTxt, 50%)
          }
        }

        .occurences {
          background-color: $darkBg2 !important;
          border-color: #999;
          color: #999;
        }

        .durationTd {
          .icon {
            color: #666
          }
        }

        .milestone {
          .bar {
            background-color: #666
          }

          .numbers {
            background-color: $darkBg2;
            color: $darkTxt;
            border-color: #666;
          }

        }

        .mergePercentTd {
        }
      }
    }

    .fakeTd {
      color: $darkTxt;

    }

    pre {
      background-color: #333;
      color: $darkTxt;
    }
  }


}
</style>
